import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import type { ComponentProps } from "react";
import { APP_FORM_DEFAULTS } from "./constants";

type Props = ComponentProps<typeof DateTimePicker> & {
  /** When false, field does not stretch to full row width (e.g. filter toolbar). */
  fullWidth?: boolean;
};

/**
 * DateTimePicker with the same outlined TextField defaults as AppTextField.
 * `ampmInClock` keeps hour/minute/AM-PM columns visible on desktop layout.
 */
export default function AppDateTimePicker({
  fullWidth = true,
  ampmInClock = true,
  slotProps,
  ...rest
}: Props) {
  return (
    <DateTimePicker
      ampmInClock={ampmInClock}
      {...rest}
      slotProps={{
        ...slotProps,
        textField: {
          size: APP_FORM_DEFAULTS.size,
          fullWidth,
          margin: APP_FORM_DEFAULTS.margin,
          ...slotProps?.textField,
        },
        popper: {
          placement: "bottom-start",
          ...slotProps?.popper,
        },
      }}
    />
  );
}
